/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Fragment, useCallback, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link, useParams} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getKontrakAll} from '../../../api/modules/kontrak'
import Pagination from '../component/Pagination'
import axios from 'axios'
import {getFile, create, deleteFile} from '../../../api/modules/file'
import {
  getAccesses,
  getKontrakSearch,
  sentToSAP,
  getCommentContract,
} from '../../../api/modules/kontrak'
import AddRemoveJadwal from './AddRemoveJadwal'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import i18next from 'i18next'
import {Spinner, Table} from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import {getSalesAreaLetter} from '../../../api/modules/getdatalist'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import RowHead from './RowHead'
import RowFilter from './RowFilter'
import {PopoverText} from '../../../components/Popover/Popover'
import {ButtonGroups} from './ButtonGroups'
import {TableLoader} from '../../../components/TableLoader'
import {TableFailedFetchData} from '../../../components/TableFailedFetchData'
import {TableEmptyData} from '../../../components/TableEmptyData'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {fetchContracts, headers} from '../../../services/fetcher'
import {objToParams} from '../../../utils/objToParams'
import {DocFlow} from '../../../components/DocFlow'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {
  filterSelector,
  resetFilterContracts,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import {StyledCard} from '../../../components/StyledCard'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {appSelector} from '../../../redux/slices/appSlices'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorKontrak} from 'src/components/BadgeColorKontrak'
import dateformat from 'src/utils/dateformat'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {setIsAmandement} from 'src/redux/slices/contractSlices'
import Skeleton from 'react-loading-skeleton'
import { concatIncoterm } from 'src/app/helpers/concat'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

type Props = {
  className: string
}

const TableKontrak: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterContracts: filter} = useAppSelector(filterSelector)
  const [tooltip, setTooltip] = useState('Open')
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()
  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 17,
    onReloadTable: () => handleReloadTable(),
  })

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [show5, setShow5] = useState(false)
  const [loadingSkeleton, setLoadingSkeleton] = useState(false)

  const [param, setParam] = useState('')

  const handleClose = () => setShow(false)

  const handleShow = async (id: any, paramm: any) => {
    setLoadingSkeleton(true)
    setShow(true)
    setIDContract(id)
    await ambilAttachment(id, paramm)
    setLoadingSkeleton(false)
  }
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose3 = () => setShow3(false)
  const handleShow3 = () => setShow3(true)
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => setShow4(true)
  const handleClose5 = () => setShow5(false)
  const handleShow5 = () => setShow5(true)

  let role = 2

  const [kontrak, setKontrak] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [isFailed, setIsFailed] = useState(false)
  const [fullcomment, setFullComment] = useState<any[]>([])
  const [showCommentCust, setShowCommentCust] = useState(false)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)

  const [roleUser, setRoleUser] = useState('')
  const [accesses, setAccesses] = useState<any>()
  const [idContract, setIDContract] = useState('')
  const [dateNow, setDateNow] = useState('')
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [filterAsc, setFilterAsc] = useState<any>('')
  const [filterCus, setFilterCus] = useState<any>('')
  const [tempRole, setTempRole] = useState<any[]>([])
  const [fullRole, setFullRole] = useState<any[]>([])
  const [fileBox, setFileBox] = useState<any>({})

  const onFetchContracts = useCallback(() => {
    setLoading(true)
    setIsFailed(false)
    fetchContracts(filter)
      .then((res) => {
        setKontrak(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsFailed(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  const [salesOrg, setSalesOrg] = useState<any>()

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getSalesOrg = async () => {
      const res = await getSalesAreaLetter()
      setSalesOrg(res.data.data)
    }

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDateNow(dd + '-' + mm + '-' + yyyy)

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }
    getSalesOrg()

    getAccessMenu()
    role()
    getAllRoleList()
  }, [])

  const paginateNumber = async (url: string) => {
    if (!url) return

    setLoading(true)

    const token = localStorage.getItem('token') as string
    const credentials = localStorage.getItem('credential') as string
    const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setKontrak(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)
  }

  // File Box

  const ambilAttachment = async (id: any, paramm: any) => {
    const res = await getFile(paramm, id, localStorage.getItem('credential')!)
    setAllFiles(res.data.data)
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [files, setFiles] = useState({file: null})
  const [allFile, setAllFiles] = useState<any[]>([])

  const clearFile = () => {
    const inputfile = document.getElementById('upload1') as HTMLInputElement
    inputfile.value = ''
    const inputfile2 = document.getElementById('upload2') as HTMLInputElement
    inputfile2.value = ''
    const inputfile3 = document.getElementById('upload3') as HTMLInputElement
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(idContract, param)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', idContract)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    if (param == 'order-item') {
      formdata.append('unique_number', idContract)
      formdata.append('unique_flag', 'new_contract_osd')
    }

    await create(param, formdata)
      .then(
        (res) => {
          // console.log(res.data);
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          }).then(() => {
            setNamaFile('')
            setDescription('')
            setIsPrivate(false)
            setDataType('')
            setTempRole([])
            setFiles({file: null})
            const inputfile = document.getElementById('upload') as HTMLInputElement
            inputfile!.value = ''
            const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
            inputPrivate.checked = false
          })
          ambilAttachment(idContract, param)
        },
        (err) => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setFiles({file: null})
          const inputfile = document.getElementById('upload') as HTMLInputElement
          inputfile!.value = ''
          swal({
            title: t(err.response.data.message),
            icon: 'error',
          })
        }
      )
      .finally(() => {
        setBtnLoading(false)
      })
  }

  // End File Box

  // Dokumen

  const [terima, setTerima] = useState('')
  const [kirim, setKirim] = useState('')
  const [ekspeditur, setEkspeditur] = useState('')
  const [resi, setResi] = useState('')
  const [filesDoc, setFilesDoc] = useState({file: null})

  // End Dokumen

  // Detail
  const navigate = useNavigate()

  const handleDetail = (kid: any, amandement: boolean) => {
    if (hakAkses?.read || roleUser == 'null') {
      dispatch(setIsAmandement(amandement))
      sessionStorage.setItem('kid', kid)
      navigate('/management/kontrak/detail/' + kid + (amandement ? '?is_amend=1' : ''))
    }
  }

  const handleEdit = (kid: any) => {
    sessionStorage.setItem('kid', kid)
    navigate(`/management/kontrak/revisi/${kid}`)
  }

  // End Detail

  const [kontrakDetail, setKontrakDetail] = useState<any>()

  const handleDetailSub = (data: any) => {
    setKontrakDetail(data)
    setShow3(true)
  }

  const toDownloadContract = async (id: any) => {
    if (hakAkses?.print) {
      const lang = i18next.language
      await axios
        .get(
          `${
            process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
          }/contract/print/loc/${id}?lang=${lang}&token=${localStorage.getItem('token')}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
              Accept: 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then(() =>
          window.open(
            `${
              process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
            }/contract/print/loc/${id}?lang=${lang}&token=${localStorage.getItem('token')}`
          )
        )
        .catch((error) =>
          swal({
            title: error.response.data.message,
            icon: 'error',
          })
        )
    }
  }

  const resendToSAP = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (confirm: any) => {
      if (confirm) {
        setLoading(true)
        await sentToSAP(id)
          .then((res) => {
            swal({
              title: `${t('Already Sent to SAP')}`,
              icon: 'success',
            }).then(() => onFetchContracts())
          })
          .catch((err: any) => {
            swal({
              title: `${t(err.response.data.message)}`,
              icon: 'error',
            })
          })
          .finally(() => setLoading(false))
      }
    })
  }

  const [showJadwal, setShowJadwal] = useState(false)
  const [ptypee, setPtype] = useState('')
  const [punit, setPUnit] = useState('')
  const [jadwalID, setJadwalID] = useState('')

  //#region state for search
  const [searchSIP, setSearchSIP] = useState('')
  const [searchNumber, setSearchNumber] = useState('')
  const [searchAnper, setSearchAnper] = useState('')
  const [searchStatus, setSearchStatus] = useState('')
  const [searchDate, setSearchDate] = useState('')
  const [searchDate2, setSearchDate2] = useState('')
  const [searchBuyer, setSearchBuyer] = useState('')
  const [searchRegarding, setSearchRegarding] = useState('')
  const [searchQuantum, setSearchQuantum] = useState<any>('')
  const [searchPrice, setSearchPrice] = useState<any>('')
  const [searchEst, setSearchEst] = useState('')
  const [searchSector, setSearchSector] = useState('')
  const [searchSAP, setSearchSAP] = useState('')
  const [searchSalesOrgCode, setSearchSalesOrgCode] = useState('')

  useEffect(() => {
    const getData = setTimeout(onFetchContracts, 1000)
    return () => clearTimeout(getData)
  }, [onFetchContracts])

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  // console.log(kontrakDetail)

  const handleDownload = async () => {
    setLoadingDownload(true)
    const params = {
      contract_number: filter?.contract_number || undefined,
      customer_name: filter?.customer_name || undefined,
      customer_name_orderby: filter?.customer_name_orderby || undefined,
      estimate_date: filter?.estimate_date || undefined,
      from_date: filter?.from_date || undefined,
      grand_total: filter?.grand_total || undefined,
      order_sub_id: filter?.order_sub_id || undefined,
      payment_type: filter?.payment_type || undefined,
      po_number: filter?.po_number || undefined,
      po_number_orderby: filter?.po_number_orderby || undefined,
      product_type: filter?.product_type || undefined,
      regarding: filter?.regarding || undefined,
      sales_org_code: filter?.sales_org_code || undefined,
      sales_org_name: filter?.sales_org_code || undefined,
      sap_number: filter?.sap_number || undefined,
      sector_id: filter?.sector_id || undefined,
      sip_number: filter?.sip_number || undefined,
      status: filter?.status || undefined,
      to_date: filter?.to_date || undefined,
      total_price: filter?.total_price || undefined,
      total_quantum: filter?.total_quantum || undefined,
      validity_date_from: filter?.validity_date_from || undefined,
      validity_date_to: filter?.validity_date_to || undefined,
      credentials: localStorage.getItem('credential'),
    }
    try {
      const res = await axios({
        url: `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract/export`,
        method: 'GET',
        params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
      const href = URL.createObjectURL(res.data)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `PI_Contract_${dateNow}.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownload(false)
    } catch {
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
      setLoadingDownload(false)
    }
  }

  const [valiDate, setValiDate] = useState<any>('')
  const [dateId, setDateId] = useState<any>()
  const [tanggal, setTanggal] = useState<any>('')
  const [bulan, setBulan] = useState<any>('')
  const [tahun, setTahun] = useState<any>('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [quantumContract, setQuantumContract] = useState('')
  const [idSektor, setIDSector] = useState(0)

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
    setQuantumContract(temp)
  }

  const handleEditDate = (id: any, date: any) => {
    let temp = date.slice(0, 10)
    let temp2 = temp.split('-')

    setTanggal(parseInt(temp2[2]))
    setBulan(parseInt(temp2[1]) - 1)
    setTahun(parseInt(temp2[0]))
    setDateId(id)
    handleShow5()
  }

  const handleSaveDate = async () => {
    setBtnLoading(true)
    const tahun: string = String(valiDate.getFullYear())
    const bulan: string = String(valiDate.getMonth() + 1)
    const hari: string = String(valiDate.getDate())
    axios
      .put(
        `${
          process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/contract/update-validity/${dateId}?credentials=${localStorage.getItem('credential')}`,
        {
          validity_date_to: tahun + '-' + bulan.padStart(2, '0') + '-' + hari.padStart(2, '0'),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((res) => {
        setBtnLoading(false)
        swal({
          title: t(res.data.message),
          icon: 'success',
        }).then(() => {
          handleClose5()
          onFetchContracts()
        })
      })
      .catch((err) => {
        setBtnLoading(false)

        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
  }

  const handleGetComment = async (id: any) => {
    setLoadingSkeleton(true)
    setShowCommentCust(true)
    await getCommentContract(id).then((res) => {
      // console.log(res.data.data)
      setFullComment(res.data.data)
    })
    setLoadingSkeleton(false)
  }

  const [filterActive, setFilterActive] = useState('true')

  const handleShowEndUser = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return <label>{temp}</label>
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleReloadTable = () => {
    dispatch(resetFilterContracts())
    onFetchContracts()
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  return (
    <StyledCard>
      {roleUser == 'null' && (
        <>
          <ButtonGroups role={roleUser} onReloadTable={handleReloadTable} />

          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead role={roleUser} />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter role={roleUser} />

                {loading ? (
                  <RowLoader />
                ) : isFailed ? (
                  <RowErrorFetch />
                ) : kontrak.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  kontrak.map((item, _index) => (
                    <Fragment key={_index}>
                      <tr>
                        <td>
                          <div className='d-flex justify-content-evenly align-items-center p-3'>
                            <button
                              className='iconArow d-flex justify-content-start align-items-center me-2'
                              data-target={'target' + item['id']}
                              title={t(tooltip)}
                              onClick={handleOpen}
                            ></button>
                            <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={'/management/kontrak/detail/' + item.id + (item.is_amendment ? '?is_amend=1' : '')}
                            >
                              12{item['contract_number']}
                            </Link>
                          </div>
                        </td>
                        <td>
                          {item['sap_number'] != null ? ( <>
                              <span
                                className='fw-bold cursor-pointer hover-underline'
                                style={{color: '#274070'}}
                                onClick={() => toDownloadContract(item.id)}
                              >
                                <u>
                                  <b>{item.sap_number}</b>
                                </u>
                              </span>
                            </>
                            ) : <span>-</span>
                          }
                        </td>
                        <td>
                          <span>{item['anper'].name}</span>
                        </td>
                        <td>
                          <span>
                            {item['perihal'] == 'PO001' ? (
                              <span className='badge badge-light-success'>{t('penjualan')}</span>
                            ) : (
                              <span className='badge badge-light-primary'>
                                {t('Non-penjualan')}
                              </span>
                            )}
                          </span>
                        </td>
                        <td>
                          <span>{t(item['sector']?.name)}</span>
                        </td>
                        <td>
                        <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={'/management/order/detail/' + parseInt(item?.sip_order?.pengajuan_order?.po_number)}
                            >
                              10{item?.sip_order?.pengajuan_order?.po_number}
                            </Link>
                        </td>
                        <td>
                        {
                            item?.sip_order?.file_path ? <>
                              <a className='fw-bold cursor-pointer hover-underline'
                              rel="noreferrer"
                              style={{color: '#274070'}} href={item?.sip_order?.file_path + "?token=" + localStorage.getItem('token')} target="_blank">11{item?.sip_order?.SIP_number}</a>
                            </> : <>{item?.sip_order?.SIP_number ? ('11'+item?.sip_order?.SIP_number)  : ''}</>
                          }
                        </td>
                        <td>
                          {item?.release_date ? (
                            <span>{dateformat(item?.release_date)}</span>
                          ) : (
                            <span className='fw-semibold d-block fs-6 text-transparent'>-</span>
                          )}
                        </td>
                        <td>
                          <span>{dateformat(item.validity_date_from)}</span>
                        </td>
                        <td>
                          <span>{dateformat(item.validity_date_to)}</span>
                        </td>
                        <td>
                          <span>
                            <PopoverText
                              content={item?.product_types ? item?.product_types : '-'}
                              index={_index}
                              className='desc-slice'
                            />
                          </span>
                        </td>
                        <td>
                          <span>
                            {i18next.language === 'en'
                              ? item?.detail_quantity?.total_tonnase?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : item?.detail_quantity?.total_tonnase?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {item.sector_id === 3 ? 'MT' : 'Ton'}
                          </span>
                        </td>
                        <td>
                          <span>
                            {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? item['grand_total']?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item['grand_total']?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }))}
                          </span>
                        </td>
                        <td>
                          <span>
                            <PopoverText
                              content={item?.payment_methods ? item?.payment_methods : '-'}
                              index={_index}
                              className='desc-slice'
                            />
                          </span>
                        </td>
                        <td>
                          <BadgeColorKontrak
                            text={item.status_text}
                            status={item.status}
                            role={roleUser}
                          />
                        </td>
                        <td>
                          <div
                            className='d-flex p-0 justify-content-center'
                            style={{marginTop: '1px', marginBottom: '1.5px'}}
                          >
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              hidden={hakAkses?.read ? false : true}
                              onClick={() => handleDetail(item['id'], item.is_amendment)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <button
                              onClick={() => {
                                handleShow(item.id, 'contract')
                                setParam('contract')
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            <button
                              onClick={() => {
                                handleGetComment(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              hidden={hakAkses?.read ? false : true}
                              title={t('Comment')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/chat-left-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={17}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('kontrak-item')}</th>
                                  <th>Sales Org</th>
                                  <th>{t('kontrak-incoterm')}</th>
                                  <th>{t('kontrak-wilayah')}</th>
                                  <th>{t('kontrak-jenis')}</th>
                                  <th>{t('kontrak-nama')}</th>
                                  <th>{t('Product Code')}</th>
                                  <th>{t('kontrak-spek')}</th>
                                  <th>{t('sub-order-kuantumD')}</th>
                                  <th>{t('Shipping Tolerance')}</th>
                                  <th>{t('Price')}</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>{t('kontrak-ppn')}</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  {item.sector_id == 2 ? <th>{t('kontrak-Gudang')}</th> : ''}
                                  <th>Status</th>
                                  <th>{t('kontrak-aksi')}</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item['order_sub_details']?.map((subItem: any, _index: number) => (
                                  <tr key={subItem?.id ?? _index}>
                                    <td>
                                      <p>{_index + 1}</p>
                                    </td>
                                    <td>
                                      <p>{subItem.produsen?.name}</p>
                                    </td>
                                    <td>
                                      {subItem.sector?.id == 2 ? (
                                        <p>
                                          {subItem.incoterm1?.code}-
                                          {subItem.incoterm2
                                            ? subItem.incoterm2?.code
                                            : subItem.incoterm2_id}
                                        </p>
                                      ) : (
                                        <p>
                                          {subItem.incoterm1?.code}
                                          {subItem.incoterm2
                                            ? '-' + subItem.incoterm2?.code
                                            : subItem.incoterm2_id == null ||
                                              subItem.incoterm2_id == '0'
                                            ? ''
                                            : '-' + subItem.incoterm2_id}
                                        </p>
                                      )}
                                    </td>
                                    <td>
                                      <p>
                                        {subItem.province?.region_name}
                                        {subItem.city?.city_name
                                          ? ', ' + subItem.city?.city_name
                                          : ''}
                                      </p>
                                    </td>
                                    <td>
                                      <p>{subItem.product_type_desc}</p>
                                    </td>
                                    <td>
                                      <p>{subItem.product_name}</p>
                                    </td>
                                    <td>
                                      <p>
                                        {parseInt(subItem.material_number) == 0
                                          ? ''
                                          : subItem.material_number.slice(-7)}
                                      </p>
                                    </td>
                                    <td>
                                      <PopoverText
                                        content={subItem.product_spec || '-'}
                                        index={_index}
                                        className='spec-slice'
                                      />
                                    </td>
                                    <td>
                                      {subItem.product_type_desc == 'KANTONG/SACK' ? (
                                        <p>
                                          {i18next.language === 'en'
                                            ? subItem.quantum_contract.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.quantum_contract.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          Pcs
                                        </p>
                                      ) : (
                                        <p>
                                          {i18next.language === 'en'
                                            ? subItem.quantum_contract.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.quantum_contract.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                        </p>
                                      )}
                                    </td>
                                    <td>
                                      <p>{subItem.shipping_tolerance_contract}%</p>
                                    </td>
                                    <td>
                                      <p>
                                        {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                          (i18next.language === 'en'
                                            ? subItem?.price_contract.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem?.price_contract.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })) +
                                          (subItem.product_type_desc == 'KANTONG/SACK'
                                            ? '/EA'
                                            : subItem?.sector?.id != 3
                                            ? '/Ton'
                                            : '/MT')}
                                      </p>
                                    </td>
                                    <td>
                                      <p>
                                        {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                          (i18next.language === 'en'
                                            ? subItem.price_before_ppn.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.price_before_ppn.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                      </p>
                                    </td>
                                    <td>
                                      <p>{subItem.ppn}%</p>
                                    </td>
                                    <td>
                                      <p>
                                        {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                          (i18next.language === 'en'
                                            ? subItem.price_after_ppn.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.price_after_ppn.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                      </p>
                                    </td>
                                    {item?.sector_id == 2 ? (
                                      <td>
                                        <p>{subItem.plant_desc}</p>
                                      </td>
                                    ) : (
                                      ''
                                    )}

                                    <td>
                                      <BadgeColorKontrak
                                        text={subItem?.status_text_contract}
                                        status={subItem?.status_contract}
                                        role={roleUser}
                                      />
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-center'>
                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title='Detail'
                                          hidden={hakAkses?.read ? false : true}
                                          onClick={() => handleDetailSub(subItem)}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/file-text-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        <button
                                          onClick={() => {
                                            setIDSector(subItem.sector_id)
                                            setProvinceName(subItem.province?.region_name)
                                            setCityName(subItem.city?.city_name)
                                            setProductName(subItem.product_name)
                                            formattingTon(subItem.quantum_contract)
                                            setJadwalID(
                                              subItem.order_sub_item_id == null
                                                ? subItem?.id
                                                : subItem?.order_sub_item_id
                                            )
                                            setShowJadwal(true)
                                            setPtype(subItem.product_type)
                                            setPUnit(subItem.unit)
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('Jadwal')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/calendar-check-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>

                                        <button
                                          onClick={() => {
                                            setFileBox(subItem)
                                            handleShow(
                                              subItem.order_sub_item_id == null
                                                ? subItem?.id
                                                : subItem?.order_sub_item_id,
                                              'order-item'
                                            )
                                            setParam('order-item')
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        <DocFlow
                                          id={
                                            subItem.order_sub_item_id == null
                                              ? subItem?.id
                                              : subItem?.order_sub_item_id
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      {roleUser != 'null' && (
        <>
          <ButtonGroups
            role={roleUser}
            hasExportAccess
            hasCreateContractAccess={hakAkses?.create}
            isDownloadLoading={loadingDownload}
            onReloadTable={handleReloadTable}
            onDownload={handleDownload}
          />

          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead role={roleUser} />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter role={roleUser} />

                {loading ? (
                  <RowLoader />
                ) : isFailed ? (
                  <RowErrorFetch />
                ) : kontrak.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  kontrak.map((item, _index) => (
                    <Fragment key={_index}>
                      <tr
                        className={
                          (item.status == 2 || item.is_amendment == true) &&
                          roleUser == 'salesAnper'
                            ? 'bg-kuning'
                            : ''
                        }
                      >
                        <td>
                          <div className='d-flex justify-content-evenly align-items-center p-3'>
                            <button
                              className='iconArow d-flex justify-content-start align-items-center me-2'
                              data-target={'target' + item['id']}
                              title={t(tooltip)}
                              onClick={handleOpen}
                              style={{margin: '-1px'}}
                            ></button>
                            <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={(item.status == 2 && roleUser == 'salesAnper') ? ('/management/kontrak/revisi/' + item.id) : ('/management/kontrak/detail/' + item.id + (item.is_amendment ? '?is_amend=1' : ''))}
                            >
                              12{item['contract_number']}
                            </Link>
                          </div>
                        </td>
                        <td>
                          {item['sap_number'] != null ? (
                            <>
                              {  hakAkses?.export ? <span
                              className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              onClick={() => toDownloadContract(item.id)}
                            >
                              {item.sap_number}
                            </span> : <span>{item['sap_number']}</span>
                              }
                            </>
                            ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item['customer']?.title == null || item['customer']?.title == ''
                                ? item['customer']?.name
                                : item['customer']?.title + ' ' + item['customer']?.name
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </td>
                        <td>
                          {item['perihal'] == 'PO001' ? (
                            <span className='badge badge-light-success'>{t('penjualan')}</span>
                          ) : (
                            <span className='badge badge-light-primary'>{t('Non-penjualan')}</span>
                          )}
                        </td>
                        <td>{t(item['sector']?.name)}</td>
                        <td>{item['anper'].name}</td>
                        <td>
                        <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={'/management/order/' + parseInt(item?.sip_order?.pengajuan_order?.po_number)}
                            >
                              10{item?.sip_order?.pengajuan_order?.po_number}
                            </Link>
                          </td>
                        <td>
                          {
                            item?.sip_order?.file_path ? <>
                              <a className='fw-bold cursor-pointer hover-underline'
                              rel="noreferrer"
                              style={{color: '#274070'}} href={item?.sip_order?.file_path + "?token=" + localStorage.getItem('token')} target="_blank">11{item?.sip_order?.SIP_number}</a>
                            </> : <>{item?.sip_order?.SIP_number ? ('11'+item?.sip_order?.SIP_number)  : ''}</>
                          }
                        {/* <Link className='fw-bold cursor-pointer hover-underline'
                              style={{color: '#274070'}}
                              to={'/management/si/' + parseInt(item?.sip_order?.SIP_number)}
                            >
                              11{item?.sip_order?.SIP_number}
                            </Link> */}
                          </td>
                        <td>
                          {item?.release_date != null ? (
                            <span>{dateformat(item?.release_date)}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          <span>{dateformat(item.validity_date_from)}</span>
                        </td>
                        <td>
                          <span>{dateformat(item.validity_date_to)}</span>
                        </td>
                        <td>
                          <PopoverText
                            content={item?.product_types ? item?.product_types : '-'}
                            index={_index}
                            className='desc-slice'
                          />
                        </td>
                        <td>
                          <span>
                            {i18next.language === 'en'
                              ? item?.detail_quantity?.total_tonnase?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : item?.detail_quantity?.total_tonnase?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            {item.sector_id === 3 ? 'MT' : 'Ton'}
                          </span>
                        </td>
                        <td>
                          <span>
                            {(item.sector_id != 3 ? 'Rp ' : 'USD ') +
                              (i18next.language === 'en'
                                ? item['grand_total']?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item['grand_total']?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }))}
                          </span>
                        </td>
                        <td>
                          <PopoverText
                            content={item?.payment_methods ? item?.payment_methods : '-'}
                            index={_index}
                            className='desc-slice'
                          />
                        </td>
                        <td>
                          <BadgeColorKontrak
                            text={item.status_text}
                            status={item.status}
                            role={roleUser}
                          />
                        </td>
                        <td>
                          <div className='d-flex p-0 justify-content-center'>
                            <button
                              hidden={hakAkses?.read ? false : true}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title='Detail'
                              onClick={() => {
                                if (item.status == 2 && roleUser == 'salesAnper') {
                                  handleEdit(item.id)
                                } else {
                                  handleDetail(item.id, item.is_amendment)
                                }
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <button
                              onClick={() => {
                                handleShow(item.id, 'contract')
                                setParam('contract')
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            {(roleUser == 'salesAnper' || roleUser == 'finance') &&
                            item.status == '13' ? (
                              <button
                                hidden={hakAkses?.update ? false : true}
                                onClick={() => resendToSAP(item['id'])}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('sentSAP')}
                              >
                                <i className='fas fa-sync-alt'></i>
                              </button>
                            ) : (
                              ''
                            )}
                            {item['status_text'] == 'Expired' && (
                              <button
                                hidden={hakAkses?.update ? false : true}
                                onClick={() => handleEditDate(item.id, item['validity_date_to'])}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('Validity Date')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/pencil-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                            <button
                              onClick={() => {
                                handleGetComment(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title={t('Comment')}
                              hidden={hakAkses?.read ? false : true}
                            >
                              <KTSVG
                                path='/media/icons/duotune/chat-left-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={17}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('kontrak-item')}</th>
                                  <th>Sales Org</th>
                                  <th>{t('kontrak-incoterm')}</th>
                                  <th>{t('kontrak-wilayah')}</th>
                                  <th>{t('kontrak-jenis')}</th>
                                  <th>{t('kontrak-nama')}</th>
                                  {item.customer?.customer_account_group != 'AR03' && (
                                    <th>{t('Product Code')}</th>
                                  )}
                                  <th>{t('kontrak-spek')}</th>
                                  <th>{t('sub-order-kuantumD')}</th>
                                  <th>{t('Shipping Tolerance')}</th>
                                  <th>{t('Price')}</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>{t('kontrak-ppn')}</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  {item.sector_id == 2 && <th>{t('kontrak-Gudang')}</th>}
                                  <th>Status</th>
                                  <th>{t('kontrak-aksi')}</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item['order_sub_details']?.map((subItem: any, _index: any) => (
                                  <tr key={subItem.id}>
                                    <td>{_index + 1}</td>
                                    {item.customer?.customer_account_group != 'AR03' ? (
                                      <>
                                        <td>
                                          <p>{subItem.produsen?.name}</p>
                                        </td>
                                        <td>
                                          {
                                            concatIncoterm(
                                              subItem.incoterm1?.code || subItem.incoterm1_id,
                                              subItem.incoterm2?.code || subItem.incoterm2_id,
                                            )
                                          }
                                        </td>
                                        <td>
                                          <p>
                                            {subItem.province?.region_name}
                                            {subItem.city?.city_name
                                              ? ', ' + subItem.city?.city_name
                                              : ''}
                                          </p>
                                        </td>
                                        <td>
                                          <p>{subItem.product_type_desc}</p>
                                        </td>
                                        <td>
                                          <p>{subItem.product_name}</p>
                                        </td>
                                        <td>
                                          <p>
                                            {parseInt(subItem.material_number) == 0
                                              ? ''
                                              : subItem.material_number.slice(-7)}
                                          </p>
                                        </td>
                                        <td>
                                          <PopoverText
                                            content={subItem.product_spec || '-'}
                                            index={_index}
                                            className='spec-slice'
                                          />
                                        </td>
                                        <td>
                                          {subItem.product_type_desc == 'KANTONG/SACK' ? (
                                            <p>
                                              {i18next.language === 'en'
                                                ? subItem.quantum_contract.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.quantum_contract.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              Pcs
                                            </p>
                                          ) : (
                                            <p>
                                              {i18next.language === 'en'
                                                ? subItem.quantum_contract.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.quantum_contract.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </p>
                                          )}
                                        </td>
                                        <td>
                                          <p>{subItem.shipping_tolerance_contract}%</p>
                                        </td>
                                        {subItem.sector?.id != 3 ? (
                                          <>
                                            <td>
                                              <p>
                                                {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                                  (i18next.language === 'en'
                                                    ? subItem?.price_contract.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem?.price_contract.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })) +
                                                  (subItem.product_type_desc == 'KANTONG/SACK'
                                                    ? '/EA'
                                                    : subItem?.sector?.id != 3
                                                    ? '/Ton'
                                                    : '/MT')}
                                              </p>
                                            </td>
                                            <td>
                                              <p>
                                                {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                                  (i18next.language === 'en'
                                                    ? subItem.price_before_ppn.toLocaleString(
                                                        'en',
                                                        {
                                                          maximumFractionDigits: 4,
                                                        }
                                                      )
                                                    : subItem.price_before_ppn.toLocaleString(
                                                        'id',
                                                        {
                                                          maximumFractionDigits: 4,
                                                        }
                                                      ))}
                                              </p>
                                            </td>
                                            <td>
                                              <p>{subItem.ppn}%</p>
                                            </td>
                                            <td>
                                              <p>
                                                {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                                  (i18next.language === 'en'
                                                    ? subItem.price_after_ppn.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : subItem.price_after_ppn.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }))}
                                              </p>
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td>
                                              <p>
                                                USD{' '}
                                                {PriceFormater(subItem?.price_contract) +
                                                  (subItem.product_type_desc == 'KANTONG/SACK'
                                                    ? '/EA'
                                                    : subItem?.sector?.id != 3
                                                    ? '/Ton'
                                                    : '/MT')}
                                              </p>
                                            </td>
                                            <td>
                                              <p>USD {PriceFormater(subItem?.price_before_ppn)}</p>
                                            </td>
                                            <td>
                                              <p>{subItem.ppn}%</p>
                                            </td>
                                            <td>
                                              <p>USD {PriceFormater(subItem?.price_after_ppn)}</p>
                                            </td>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <td>
                                          <p>{subItem.produsen?.name}</p>
                                        </td>
                                        <td>
                                          {
                                            concatIncoterm(
                                              subItem.incoterm1?.code || subItem.incoterm1_id,
                                              subItem.incoterm2?.code || subItem.incoterm2_id,
                                            )
                                          }
                                        </td>
                                        <td>
                                          <p>
                                            {subItem.province?.region_name}
                                            {subItem.city?.city_name
                                              ? ', ' + subItem.city?.city_name
                                              : ''}
                                          </p>
                                        </td>
                                        <td>
                                          <p>{subItem.product_type_desc}</p>
                                        </td>
                                        <td>
                                          <p>{subItem.product_name}</p>
                                        </td>
                                        <td>
                                          <PopoverText
                                            content={subItem.product_spec || '-'}
                                            index={_index}
                                            className='spec-slice'
                                          />
                                        </td>
                                        <td>
                                          {subItem.product_type_desc == 'KANTONG/SACK' ? (
                                            <p>
                                              {i18next.language === 'en'
                                                ? subItem.quantum_contract.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.quantum_contract.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              Pcs
                                            </p>
                                          ) : (
                                            <p>
                                              {i18next.language === 'en'
                                                ? subItem.quantum_contract.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.quantum_contract.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })}{' '}
                                              {subItem.sector_id === 3 ? 'MT' : 'Ton'}
                                            </p>
                                          )}
                                        </td>
                                        <td>
                                          <p>{subItem.shipping_tolerance_contract}%</p>
                                        </td>
                                        <td>
                                          <p>
                                            {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                              (i18next.language === 'en'
                                                ? subItem?.price_contract.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem?.price_contract.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })) +
                                              (subItem.product_type_desc == 'KANTONG/SACK'
                                                ? '/EA'
                                                : subItem?.sector?.id != 3
                                                ? '/Ton'
                                                : '/MT')}
                                          </p>
                                        </td>
                                        <td>
                                          <p>
                                            {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                              (i18next.language === 'en'
                                                ? subItem.price_before_ppn.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.price_before_ppn.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }))}
                                          </p>
                                        </td>
                                        <td>
                                          <p>{subItem.ppn}%</p>
                                        </td>
                                        <td>
                                          <p>
                                            {(subItem?.sector?.id != 3 ? 'Rp ' : 'USD ') +
                                              (i18next.language === 'en'
                                                ? subItem.price_after_ppn.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : subItem.price_after_ppn.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }))}
                                          </p>
                                        </td>
                                      </>
                                    )}
                                    {item.sector_id == 2 ? (
                                      <td>
                                        <p>{subItem.plant_desc}</p>
                                      </td>
                                    ) : (
                                      ''
                                    )}
                                    <td>
                                      <BadgeColorKontrak
                                        text={subItem.status_text_contract}
                                        status={subItem.status_contract}
                                        role={roleUser}
                                      />
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-center'>
                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                          title='Detail'
                                          hidden={hakAkses?.read ? false : true}
                                          onClick={() => handleDetailSub(subItem)}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/file-text-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>

                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          title={t('Jadwal')}
                                          onClick={() => {
                                            setIDSector(subItem.sector_id)
                                            setProvinceName(subItem.province?.region_name)
                                            setCityName(subItem.city?.city_name)
                                            setProductName(subItem.product_name)
                                            formattingTon(subItem.quantum_contract)
                                            setJadwalID(
                                              subItem.order_sub_item_id == null
                                                ? subItem?.id
                                                : subItem?.order_sub_item_id
                                            )
                                            setShowJadwal(true)
                                            setPtype(subItem.product_type)
                                          }}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/calendar-check-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>

                                        <button
                                          onClick={() => {
                                            setFileBox(subItem)
                                            handleShow(
                                              subItem.order_sub_item_id == null
                                                ? subItem?.id
                                                : subItem?.order_sub_item_id,
                                              'order-item'
                                            )
                                            setParam('order-item')
                                          }}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          title={t('order-lampiran')}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/archive-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                        <DocFlow
                                          id={
                                            subItem.order_sub_item_id == null
                                              ? subItem?.id
                                              : subItem?.order_sub_item_id
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      <Modal show={show5} onHide={handleClose5} centered backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>
            {t('ubah')} {t('Validity Date')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>{t('Validity Date')}</Form.Label>
          <Calendar
            className='w-100'
            defaultValue={new Date(tahun, bulan, tanggal)}
            // activeStartDate={new Date(tahun, bulan, tanggal)}
            onChange={setValiDate}
          />
          <div className='d-flex justify-content-end mt-5'>
            <Button variant='primary' onClick={handleSaveDate}>
              {btnLoading ? <Spinner animation='border' size='sm' /> : t('save')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        size='lg'
        show={show}
        onHide={() => {
          setShow(false)
          setIsPrivate(false)
          setTempRole([])
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.quantum_contract ? ' | ' + fileBox.quantum_contract + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {loadingSkeleton ? (
              <>
                <Col lg={6}>
                  <Skeleton count={3} height={30} />
                </Col>
              </>
            ) : (
              <>
                {!downloadOnly ? (
                  <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                                isBase64={false}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              id='uploadketerangan'
                              placeholder={t('order-keterangan')}
                              onChange={(e: any) => setDescription(e.target.value)}
                              value={description}
                            />
                          </td>
                        </tr>
                      </table>
                      <table
                        className='mb-3'
                        hidden={roleUser == 'null' || roleUser == null ? true : false}
                      >
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate'
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                                setTempRole([])
                              }}
                              id='isPrivate'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={isPrivate.toString()}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-end'>
                        <Button
                          variant='primary'
                          className='w-100'
                          onClick={() => handleUpload()}
                          disabled={btnLoading}
                        >
                          {btnLoading ? (
                            <Spinner animation='border' variant='light' size='sm' />
                          ) : (
                            t('order-kirim')
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <></>
                )}
                {allFile.length < 1 || allFile.length == undefined ? (
                  <></>
                ) : (
                  <>
                    <div className='table-responsive mt-4 bdr' style={{marginTop: '3rem'}}>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead className='border-bottom'>
                          <tr className=''>
                            <th className='text-center'>{t('order-noo')}</th>
                            <th className='text-center'>{t('order-keterangan')}</th>
                            <th className='text-center'>{t('order-tglUpload')}</th>
                            <th className='text-center'>{t('User Code')}</th>
                            <th className='text-center'>{t('order-user')}</th>
                            <th className='text-center'>{t('Akses Role')}</th>
                            <th className='text-center'>{t('order-aksi')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allFile.map((data: any, _index: number) => (
                            <tr key={data?.id ?? _index} className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(data.updated_at)}</label>
                              </td>
                              <td className='text-center'>
                                <label>
                                  {data.user?.customer_code || data.user?.nama_pengguna}
                                </label>
                              </td>
                              <td className='text-center'>
                                {data.user?.customer != null ? (
                                  <label>{data.user?.customer?.name}</label>
                                ) : (
                                  <label>{data.user?.name}</label>
                                )}
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleName(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() =>
                                    handleDownloadAttachment(
                                      data.file_path
                                    )
                                  }
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                {(hakAkses?.attachment_delete ||
                                  CheckSameIDAttachment(data.user_role_flag)) && (
                                  <button
                                    onClick={() => deleteAttachment(data.id)}
                                    className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </>
            )}
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={show3} onHide={handleClose3} centered scrollable size='xl' backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {kontrakDetail?.sector_id == 1 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>Sales Org</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.incoterm1?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={kontrakDetail.province?.region_name}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('Plant')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control value={kontrakDetail.plant_desc} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>
                      {kontrakDetail.product_type_desc == 'KANTONG/SACK'
                        ? t('sack')
                        : t('sub-order-kuantum')}
                    </p>
                  </Col>
                  <Col md={7}>
                    {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                            : parseFloat(kontrakDetail?.quantum_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                            : parseFloat(kontrakDetail?.quantum_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={5}>
                    <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                  </Col>
                  <Col sm={7}>
                    <Form.Control
                      size='sm'
                      type='text'
                      id='shipping'
                      value={
                        kontrakDetail?.shipping_tolerance_contract != '0'
                          ? kontrakDetail?.shipping_tolerance_contract + ' %'
                          : ''
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail?.payment_type_1_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={t(kontrakDetail?.payment_note)}
                      as='textarea'
                      disabled
                      size='sm'
                      style={{height: '40px'}}
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        kontrakDetail.end_user_multiple
                          ? handleShowValue(kontrakDetail?.end_user)
                          : kontrakDetail?.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={t(kontrakDetail.sector?.name)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={7}>
                    {kontrakDetail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          kontrakDetail?.incoterm2_id == null || kontrakDetail?.incoterm2_id == '0'
                            ? ''
                            : kontrakDetail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={kontrakDetail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={kontrakDetail.city?.city_name}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.product_name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={7}>
                    <FieldProductSpec data={kontrakDetail.product_spec} type='editor' />
                  </Col>
                </Row>
                <Row className='mb-2'>
                  <Col md={5}>
                    {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? (
                      <p className='fs-6 mt-3'>{t('sub-order-hargaD')}/EA</p>
                    ) : (
                      <p className='fs-6 mt-3'>{t('sub-order-hargaD')}/Ton</p>
                    )}
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        'Rp ' + (i18next.language === 'en'
                          ? parseInt(kontrakDetail?.price_contract).toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : parseInt(kontrakDetail?.price_contract).toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })
                      )}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                {/* <Row className='mb-5'>
                  <Col sm={5}>
                    <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                  </Col>
                  <Col sm={7} className='d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='ppn'
                      className='mt-4 mb-2'
                      type='checkbox'
                      id='ckbox-ppn'
                      checked={kontrakDetail?.include_ppn}
                    />
                  </Col>
                </Row> */}
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail?.payment_type_2_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('segment')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={t(kontrakDetail.segment_name)}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail?.notes}
                      as='textarea'
                      style={{height: '40px'}}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                { kontrakDetail?.sector_id != 2 && <>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.amandement_notes}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.extension_date}
                      type={kontrakDetail.extension_date ? 'date' : 'text'}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                </> }
              </Col>
            </Row>
          )}

          {kontrakDetail?.sector_id == 3 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>Sales Org</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.incoterm1?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={kontrakDetail.province?.region_name}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('Plant')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control value={kontrakDetail.plant_desc} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    {kontrakDetail.product_type_desc != 'KANTONG/SACK' ? (
                      <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                    ) : (
                      <p className='mt-3 fs-6'>{t('sack')}</p>
                    )}
                  </Col>
                  <Col md={7}>
                    {kontrakDetail.product_type_desc == 'KANTONG/SACK' ? (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                            : parseFloat(kontrakDetail?.quantum_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' EA'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' MT'
                            : parseFloat(kontrakDetail?.quantum_contract).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' MT'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col sm={5}>
                    <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                  </Col>
                  <Col sm={7}>
                    <Form.Control
                      size='sm'
                      type='text'
                      id='shipping'
                      value={
                        kontrakDetail?.shipping_tolerance_contract != '0'
                          ? kontrakDetail?.shipping_tolerance_contract + ' %'
                          : ''
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail?.payment_type_1_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={t(kontrakDetail?.payment_note)}
                      as='textarea'
                      disabled
                      size='sm'
                      style={{height: '40px'}}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={t(kontrakDetail.sector?.name)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={7}>
                    {kontrakDetail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          kontrakDetail?.incoterm2_id == null || kontrakDetail?.incoterm2_id == '0'
                            ? ''
                            : kontrakDetail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={kontrakDetail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={kontrakDetail.city?.city_name}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.product_name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={7}>
                    <FieldProductSpec data={kontrakDetail.product_spec} type='editor' />
                  </Col>
                </Row>
                <Row className='mb-2'>
                  <Col md={5}>
                    {kontrakDetail.product_type_desc != 'KANTONG/SACK' ? (
                      <p className='fs-6 mt-3'>{t('sub-order-hargaD')}/MT</p>
                    ) : (
                      <p className='fs-6 mt-3'>{t('sub-order-hargaD')}/EA</p>
                    )}
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={'USD' + PriceFormater(kontrakDetail?.price_contract)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail?.notes}
                      as='textarea'
                      style={{height: '40px'}}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail?.payment_type_2_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={
                        kontrakDetail.end_user_multiple
                          ? handleShowValue(kontrakDetail?.end_user)
                          : kontrakDetail?.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>

                { kontrakDetail?.sector_id != 2 && <>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.amandement_notes}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={5}>
                    <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={kontrakDetail.extension_date}
                      type={kontrakDetail.extension_date ? 'date' : 'text'}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                </> }
              </Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showJadwal}
        onHide={() => {
          setShowJadwal(false)
          setJadwalID('')
        }}
        centered
        size='xl'
        backdrop='static'
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
            {productName} | {quantumContract} {ptypee != '8105' ? 'Ton' : punit}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddRemoveJadwal id={jadwalID} is_amendment={'false'} tipeproduct={ptypee} unit={punit}/>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCommentCust}
        onHide={() => setShowCommentCust(false)}
        centered
        backdrop='static'
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Comment')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingSkeleton ? (
            <>
              <Skeleton height={30} />
            </>
          ) : (
            <>
              {fullcomment?.length < 1 ? (
                <div>{t('No Comment')}</div>
              ) : (
                <div className='table-responsive mt-10 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold w-100 align-items-center'>
                        <th className='td-3 text-center'>{t('no')}</th>
                        <th className='td-3 text-center'>{t('order-tanggal')}</th>
                        <th className='td-3 text-center'>{t('order-user')}</th>
                        <th className='td-3 text-center'>Status</th>
                        <th className='td-3 text-center'>{t('Comment')}</th>
                      </tr>
                    </thead>
                    {fullcomment?.map((item: any, _index: any) => (
                      <tbody key={item?.id ?? _index}>
                        <tr className='w-100 align-items-center'>
                          <td className='td-150 text-center'>{_index + 1}</td>
                          <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                          <td className='td-150 text-center'>{item.user?.name}</td>
                          <td className='td-150 text-center'>
                            {item.type == 6
                              ? t('order-revisi')
                              : item.type == 7
                              ? t('Ditolak')
                              : ''}
                          </td>
                          <td className='td-60 text-center text-truncate'>
                            <PopoverText
                              content={item.comment}
                              index={_index}
                              className='desc-slice'
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                  {/* End Table Head */}
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {TableKontrak}
